import { MCell } from './cell';
import { EMTableOperationDirection, IMCell, IMCellIndex, IMCells, IMTable } from './typings';
import { DEFAULT_ADD_CELL } from './utils';

export class MTable {
  id: string;
  mask: number[][];
  cells: MCell[][] = [];
  textMatrix: string[][];

  get cellsRowCount(): number {
    return this.cells.length;
  }

  get cellsColCount(): number {
    if (this.cells.length === 0) {
      return 0;
    }

    return this.cells[0].length;
  }

  private source: IMTable;

  constructor(source: IMTable) {
    this.source = source;
    this.id = source.table_id;
    this.mask = source.mask;
    this.composeCells(source.cells);
    this.textMatrix = source.text_matrix;
  }

  updateCellText(rowIndex: number, colIndex: number, text: string): void {
    this.source.cells[rowIndex][colIndex].text = text;
    this.cells[rowIndex][colIndex].updateText(text);
  }

  highlightCells(data: IMCellIndex[]): void {
    this.cells.forEach(r => r.forEach(c => (c.source.highlight = false)));
    data.forEach(({ rowIndex, colIndex }) => {
      if (this.cells[rowIndex] && this.cells[rowIndex][colIndex]) { this.cells[rowIndex][colIndex].source.highlight = true; }
    });
  }

  clearHighlightCells(): void {
    this.cells.forEach(r => r.forEach(c => (c.source.highlight = false)));
  }

  private composeCells(data: IMCells): void {
    this.cells = [];
    data.forEach((cellRow, rowIndex) => {
      this.cells[rowIndex] = [];
      cellRow.forEach(cell => {
        this.cells[rowIndex].push(new MCell(cell));
      });
    });
  }

  addRow(direction: EMTableOperationDirection, rowIndex: number, defaultCell: IMCell = { ...DEFAULT_ADD_CELL }): void {
    const position = direction === EMTableOperationDirection.before ? 0 : 1;
    const newCells: MCell[] = [];
    this.source.cells[0].forEach(_item => {
      newCells.push(new MCell({ ...defaultCell }));
    });
    this.source.cells.splice(
      rowIndex + position,
      0,
      newCells.map(e => e.toJson())
    );
    this.source.mask.push(this.source.mask[0].map(() => 0));
    this.source.text_matrix.splice(rowIndex + position, 0, Array(newCells.length).fill(''));
    this.cells.splice(rowIndex + position, 0, newCells);
  }

  deleteRow(rowIndex: number): void {
    this.source.cells.splice(rowIndex, 1);
    this.source.mask.splice(rowIndex, 1);
    this.source.text_matrix.splice(rowIndex, 1);
    this.cells.splice(rowIndex, 1);
  }

  addColumn(direction: EMTableOperationDirection, colIndex: number, defaultCell: IMCell = { ...DEFAULT_ADD_CELL }): void {
    const position = direction === EMTableOperationDirection.before ? 0 : 1;
    this.source.cells.forEach(item => {
      item.splice(colIndex + position, 0, { ...defaultCell });
    });
    this.source.mask.forEach(item => {
      item.splice(colIndex + position, 0, 0);
    });
    this.source.text_matrix.forEach(item => {
      item.splice(colIndex + position, 0, '');
    });
    this.cells.forEach(item => {
      item.splice(colIndex + position, 0, new MCell({ ...defaultCell }));
    });
  }

  deleteColumn(colIndex: number): void {
    this.source.cells.forEach(item => {
      item.splice(colIndex, 1);
    });
    this.source.mask.forEach(item => {
      item.splice(colIndex, 1);
    });
    this.source.text_matrix.forEach(item => {
      item.splice(colIndex, 1);
    });
    this.cells.forEach(item => {
      item.splice(colIndex, 1);
    });
  }
}
